var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronRightWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Chevron.Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.64645 2.81344C5.45118 3.0087 5.45118 3.32528 5.64645 3.52055L10.1262 8.00032L5.64645 12.4801C5.45118 12.6754 5.45118 12.9919 5.64645 13.1872C5.84171 13.3825 6.15829 13.3825 6.35355 13.1872L11.1869 8.35388C11.3821 8.15862 11.3821 7.84203 11.1869 7.64677L6.35355 2.81344C6.15829 2.61818 5.84171 2.61818 5.64645 2.81344Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRightWhite);
export default __webpack_public_path__ + "static/media/icon-chevron-right-white.ccd11eb7274f1d4c2fcaa6bb2a303f6d.svg";
export { ForwardRef as ReactComponent };